// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cc-box{border-radius:16px!important}.cc-title{font-weight:300;font-size:12px;opacity:.64}.cc-content,.cc-title{color:#3a3a3a;line-height:100%}.cc-content{font-size:16px}.cc-copy-button{min-width:0!important}", ""]);
// Exports
module.exports = exports;
